export const IS_REQUIRED = 'Povinné pole'
export const INVALID_IDENTIFICATION_NUMBER = 'Neplatné rodné číslo'
export const INVALID_EMAIL = 'Neplatná e-mailová adresa'
// eslint-disable-next-line no-template-curly-in-string
export const MIN_CHARACTERS = 'Minmální množství znaků: ${min}'
// eslint-disable-next-line no-template-curly-in-string
export const MAX_CHARACTERS = 'Maximální množství znaků: ${max}'

export const IS_NUMBER = 'Musí být číslo'

export const MOBILE_PHONE_MISSING_PREFIX =
  'Číslo mobilního telefonu musí obsahovat předvolbu +420 nebo +421.'
export const MOBILE_PHONE_INVALID_FORMAT = 'Chybný formát telefonního čísla.'

// eslint-disable-next-line no-template-curly-in-string
export const MIN_NUMBER = 'Číslo musí být alespoň ${min}'
// eslint-disable-next-line no-template-curly-in-string
export const MAX_NUMBER = 'Číslo musí být měnší než ${max}'
